import { Icon } from "materia"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import type { PeerProfile } from "../../types"
import { PeerAvatar, PeerAvatarGroup } from "../PeerAvatar"
import s from "./ThreadHeader.module.scss"

type ThreadHeaderProps = {
  name: string
  /** One person for a direct conversation, the members for a group. */
  faces: PeerProfile[]
  /** Groups only — a direct conversation has nothing to count. */
  memberCount?: number
  isDirect?: boolean
  onBack: () => void
  /** Groups only: the group's actions, beside its faces. */
  menu?: ReactNode
}

export function ThreadHeader({
  name,
  faces,
  memberCount,
  isDirect = false,
  onBack,
  menu,
}: ThreadHeaderProps) {
  const { t } = useTranslation()

  return (
    <header className={s.header}>
      <button
        className={s.header__back}
        type="button"
        onClick={onBack}
        aria-label={String(t("chat.BACK_ARIA"))}
      >
        <Icon icon="Chevron" rotate={180} />
      </button>

      <span className={s.header__names}>
        <p className={s.header__name}>{name}</p>
        {memberCount !== undefined ? (
          <p className={s.header__subtitle}>
            {t("chat.MEMBER_COUNT", { count: memberCount })}
          </p>
        ) : (
          isDirect && (
            <p className={s.header__subtitle}>
              {t("chat.DIRECT_CONVERSATION")}
            </p>
          )
        )}
      </span>

      {faces.length > 1 ? (
        <PeerAvatarGroup members={faces} size="small" />
      ) : (
        faces[0] && <PeerAvatar {...faces[0]} size="small" />
      )}
      {menu}
    </header>
  )
}
